/**
 * <Fade> — a single gated fade+rise entrance wrapper.
 *
 * Renders one `<motion.*>` element (default `div`) that fades + rises in on
 * mount, or mounts statically under reduced motion. Forwards `className`,
 * `data-testid`, and `ref` so wrapping an element never moves its e2e selector.
 */
import { motion } from "framer-motion";
import { forwardRef, type Ref } from "react";

import { MOTION_TAGS, type MotionWrapperProps } from "@/components/motion/shared";
import { useGardenMotion } from "@/lib/use-garden-motion";

export const Fade = forwardRef<HTMLElement, MotionWrapperProps>(function Fade(
  { as = "div", className, children, "data-testid": testId },
  ref,
) {
  const { entrance } = useGardenMotion();
  const Comp = MOTION_TAGS[as] as typeof motion.div;
  return (
    <Comp
      ref={ref as Ref<HTMLDivElement>}
      className={className}
      data-testid={testId}
      {...entrance("item")}
    >
      {children}
    </Comp>
  );
});
